import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/app/(main)/wishlists/WishlistsPageClient.tsx");
